export const TopicID = "sprints-for-user";
export const TopicNameRegExp = new RegExp('/DEPRECATED/');
export const SubscriptionParamsSchema = { type: "null" };
